import React, { PureComponent } from 'react'
import { connect } from 'react-redux'

import LoadingOverlay from 'components/common/LoadingOverlay'
import PressMessageCard from 'components/common/PressMessageCard'

import {
  fetchMessages
} from './duck'

import './style.scss'

class PressMessages extends PureComponent {

  fetchMessages = (languageCode) => {
    this.props.dispatch(fetchMessages(null, languageCode))
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.currentLanguage !== nextProps.currentLanguage) {
      this.fetchMessages(nextProps.currentLanguage)
    }
  }

  componentWillMount = () => {
    this.fetchMessages(this.props.currentLanguage)
  }

  render() {
    const {
      loading,
      messages,
      lng
    } = this.props

    return (
      <div className="pressMessages">
        {loading ? <LoadingOverlay /> : null}
        {
          messages ? messages.map(message => (
            <PressMessageCard
              lng={lng}
              key={message.Id}
              id={message.Id}
              date={message.CreateDate}
              header={message.Title}
              content={message.Message}
              showImage={message.HasImage}
              messageType={message.CategoryId === 1002 ? lng.PressRoom.SaidAboutUs : lng.PressRoom.Pressmessage}
              typeColor={message.CategoryId === 1002 ? '#720A7B' : '#0A7B7A'}
              externalLink={message.Url}
            />
          )) : null
        }
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  loading: state.pressroom.messages.loading,
  messages: state.pressroom.messages.items,
  currentLanguage: state.app.currentLanguage,
  lng: state.app.language
})

export default connect(mapStateToProps)(PressMessages)